module.exports = __webpack_public_path__ + "img/wxqrcode.5d65025c.svg";